module.exports = __webpack_public_path__ + "img/Banner.a3c142a4.svg";